import styled from "styled-components";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

export const LeftPanelScrollbar = styled(SimpleBar)`
  .simplebar-scrollbar.simplebar-visible {
    color: #c1c1c4;
  }
`;
